// extracted by mini-css-extract-plugin
module.exports = {"PollsPage__title":"PollsPage_PollsPage__title__ZAN6k","PollsPage__TitleInner":"PollsPage_PollsPage__TitleInner__3NDj-","PollsPage__search":"PollsPage_PollsPage__search__fMcHZ"};